<div class="wrapper bg-area">
  <section id="confirmacao">
    <div class="container area-faca-parte">
      <div class="header-faca-parte columns">
        <div class="column is-6" style="margin: 0px auto;">
          <div class="bar__container">
            <ul class="bar" id="bar">
              <li class="active active-step"><i class="fas fa-check"></i>Plano</li>
              <li class="active active-step"><i class="fas fa-check"></i>Dados Pessoais</li>
              <li class="active active-step"><i class="fas fa-check"></i>Pagamento</li>
              <li class="active active-step"><i class="fas fa-check"></i>Segurança</li>
              <li class="active active-step"><i class="fas fa-check"></i>Confirmação</li>
            </ul>
          </div>
        </div>
      </div>
      <form>
        <div class="body-faca-parte columns">
          <div class="column is-6" style="margin: 0px auto;">

            <div class="dados-pessoais">

              <div class="text-center">
                <img class="icon-montreal" src="assets/img/icon-sucesso-cadastro.png" />
                <h2>PROPOSTA EM ANÁLISE!</h2>
              </div>


              <p><strong>Sua proposta já está sendo analizada.</strong></p>
              <p>
                <strong>Enquanto suas informações estão Sendo Processadas, você pode dar uma olhada nos <a
                    href="/hoteis">Nossos Hotéis</a> ou Acessar o <a
                    href="https://www.clubemontreal.com.br/portal-cliente/">Portal do Cliente</a>.</strong>
                <br><br>Assim que tivermos um retorno, eu te envio um email, ok?
              </p>
              <p>Caso tenha alguma dúvida ou não receba minha mensagem em até 48hs,
                verifique sua Caixa de Spam ou Entre em Contato conosco pelo <a
                  href="https://sac-clubemontreal.ascbrazil.com.br/Chat/id/Clube_Montreal" target="_blank">Chat</a> ou
                pela Central de Atendimento no <strong><a href="tel:0800 610 3311">0800 61 3311</a></strong></p>
              <br />
            </div>
          </div>
        </div>
      </form>
    </div>
  </section>
</div>
